export default __webpack_public_path__ + "static/media/LaptopScreen.81bd7dac.png";